export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/spokesperson_nl-NL.a2e5816.vtt";